export { default } from './useIsComponentMounted';

export type * from './types';
